var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBikeCargo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.396,
    height: 14,
    viewBox: "0 0 18.396 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    transform: "translate(-1117.478 -603.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    d: "M1160.624,605.75a1.262,1.262,0,1,0-1.709-.514A1.266,1.266,0,0,0,1160.624,605.75Z",
    transform: "translate(-30.155)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    d: "M1158.011,618.1a3.705,3.705,0,0,0-1.483.307l-1.39-.45.617-2.051.684.206a4.412,4.412,0,0,0,2.8-.06.634.634,0,0,0,.335-.9.642.642,0,0,0-.768-.3,3.165,3.165,0,0,1-1.956.027l-1.624-.489a1.549,1.549,0,0,0-1.068.145,1.059,1.059,0,0,0-.6.752l-.72,2.393a1.246,1.246,0,0,0,.085.957,1.058,1.058,0,0,0,.752.6l1.4.321a3.654,3.654,0,0,0-.716,2.187,3.651,3.651,0,1,0,3.65-3.651Zm0,6.206a2.587,2.587,0,0,1-2.555-2.555,2.554,2.554,0,0,1,.852-1.884l1.182,2.2a.631.631,0,1,0,1.112-.6l-1.182-2.2a2.458,2.458,0,0,1,.591-.075,2.555,2.555,0,1,1,0,5.111Z",
    transform: "translate(-25.788 -8.022)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    d: "M1124.928,603.377h-5.854a1.6,1.6,0,0,0-1.6,1.6v5.853a1.6,1.6,0,0,0,1.134,1.528,3.714,3.714,0,0,0-.26,1.371,3.651,3.651,0,0,0,7.3,0,3.716,3.716,0,0,0-.261-1.371,1.6,1.6,0,0,0,1.134-1.528v-5.853A1.6,1.6,0,0,0,1124.928,603.377Zm-2.927,12.9a2.587,2.587,0,0,1-2.555-2.555,2.5,2.5,0,0,1,.371-1.3h4.368a2.5,2.5,0,0,1,.372,1.3A2.587,2.587,0,0,1,1122,616.282Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeCargo);
export default __webpack_public_path__ + "static/media/bike-cargo.aec8b929.svg";
export { ForwardRef as ReactComponent };